module.exports = __webpack_public_path__ + "static/media/jetpress-logo-white.21cd08bf.svg";